import React from 'react';

function Tuvalu(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123974)">
        <mask
          id="mask0_800_123974"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123974)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#00B4FF"
          />
          <mask
            id="mask1_800_123974"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123974)">
            <rect width="20.25" height="14" fill="#2B409A" />
            <mask
              id="mask2_800_123974"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="21"
              height="14"
            >
              <rect width="20.25" height="14" fill="white" />
            </mask>
            <g mask="url(#mask2_800_123974)">
              <path
                d="M-2.25488 12.9998L2.20119 14.737L20.351 1.88872L22.7015 -0.69281L17.9364 -1.27343L10.5335 4.26326L4.57493 7.99369L-2.25488 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M-1.64502 14.2169L0.625142 15.225L21.8573 -0.932678H18.6697L-1.64502 14.2169Z"
                fill="#F50100"
              />
              <path
                d="M22.5049 12.9998L18.0488 14.737L-0.101032 1.88872L-2.45151 -0.69281L2.31362 -1.27343L9.71651 4.26326L15.6751 7.99369L22.5049 12.9998Z"
                fill="#F7FCFF"
              />
              <path
                d="M22.353 13.8733L20.0829 14.8815L11.042 7.96351L8.36158 7.19059L-2.67748 -0.683947H0.510086L11.5429 7.00368L14.4735 7.9305L22.353 13.8733Z"
                fill="#F50100"
              />
              <mask
                id="path-11-outside-1_800_123974"
                maskUnits="userSpaceOnUse"
                x="-2"
                y="-2"
                width="24"
                height="18"
                fill="black"
              >
                <rect fill="white" x="-2" y="-2" width="24" height="18" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                />
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2326 0H8.98256V6H0V8H8.98256V14H11.2326V8H20.25V6H11.2326V0Z"
                fill="#F50100"
              />
              <path
                d="M8.98256 0V-1.5H7.48256V0H8.98256ZM11.2326 0H12.7326V-1.5H11.2326V0ZM8.98256 6V7.5H10.4826V6H8.98256ZM0 6V4.5H-1.5V6H0ZM0 8H-1.5V9.5H0V8ZM8.98256 8H10.4826V6.5H8.98256V8ZM8.98256 14H7.48256V15.5H8.98256V14ZM11.2326 14V15.5H12.7326V14H11.2326ZM11.2326 8V6.5H9.73256V8H11.2326ZM20.25 8V9.5H21.75V8H20.25ZM20.25 6H21.75V4.5H20.25V6ZM11.2326 6H9.73256V7.5H11.2326V6ZM8.98256 1.5H11.2326V-1.5H8.98256V1.5ZM10.4826 6V0H7.48256V6H10.4826ZM0 7.5H8.98256V4.5H0V7.5ZM1.5 8V6H-1.5V8H1.5ZM8.98256 6.5H0V9.5H8.98256V6.5ZM10.4826 14V8H7.48256V14H10.4826ZM11.2326 12.5H8.98256V15.5H11.2326V12.5ZM9.73256 8V14H12.7326V8H9.73256ZM20.25 6.5H11.2326V9.5H20.25V6.5ZM18.75 6V8H21.75V6H18.75ZM11.2326 7.5H20.25V4.5H11.2326V7.5ZM9.73256 0V6H12.7326V0H9.73256Z"
                fill="#F7FCFF"
                mask="url(#path-11-outside-1_800_123974)"
              />
            </g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.2139 10.6849L30.897 9.55941L32.3956 9.51962L31.2353 8.65823L31.6353 7.49563L30.635 8.02986L29.3705 7.34821L29.4929 8.63987L28.3599 9.24499L29.8307 9.4084L30.2139 10.6849ZM26.397 11.5594L25.7139 12.6849L25.3307 11.4084L23.8599 11.245L24.9929 10.6399L24.8705 9.34821L26.135 10.0299L27.1353 9.49563L26.7353 10.6582L27.8956 11.5196L26.397 11.5594ZM23.4639 14.6849L24.147 13.5594L25.6456 13.5196L24.4853 12.6582L24.8853 11.4956L23.885 12.0299L22.6205 11.3482L22.7429 12.6399L21.6099 13.245L23.0807 13.4084L23.4639 14.6849ZM18.9639 18.6849L19.647 17.5594L21.1456 17.5196L19.9853 16.6582L20.3853 15.4956L19.385 16.0299L18.1205 15.3482L18.2429 16.6399L17.1099 17.245L18.5807 17.4084L18.9639 18.6849ZM14.596 21.7356L13.3583 22.3876L13.7695 21.118L12.6035 20.3046H13.9253L14.5688 19.1414L15.2577 20.3046H16.4246L15.4081 21.118L15.9036 22.3876L14.596 21.7356ZM19.647 21.5594L18.9639 22.6849L18.5807 21.4084L17.1099 21.245L18.2429 20.6399L18.1205 19.3482L19.385 20.0299L20.3853 19.4956L19.9853 20.6582L21.1456 21.5196L19.647 21.5594ZM24.147 19.5594L23.4639 20.6849L23.0807 19.4084L21.6099 19.245L22.7429 18.6399L22.6205 17.3482L23.885 18.0299L24.8853 17.4956L24.4853 18.6582L25.6456 19.5196L24.147 19.5594ZM28.647 17.5594L27.9639 18.6849L27.5807 17.4084L26.1099 17.245L27.2429 16.6399L27.1205 15.3482L28.385 16.0299L29.3853 15.4956L28.9853 16.6582L30.1456 17.5196L28.647 17.5594ZM30.2139 16.6849L30.897 15.5594L32.3956 15.5196L31.2353 14.6582L31.6353 13.4956L30.635 14.0299L29.3705 13.3482L29.4929 14.6399L28.3599 15.245L29.8307 15.4084L30.2139 16.6849Z"
              fill="#FFD018"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123974">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Tuvalu;
